import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPreguntasTalentoStartService,
  getPreguntasTalentoCurrentService,
  sendPreguntasTalentoAnswerService,
  getPreguntasTalentoStatusService,
  getPreguntasTalentoSummaryService,
} from "../../services/preguntasTalentoQuiz/preguntasTalentoQuiz.service";

export const getPTQuizStartThunk = createAsyncThunk(
  "preguntasTalentoQuiz/getStart",
  async (_, { rejectWithValue }) => {
    try {
      return await getPreguntasTalentoStartService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al iniciar el quiz."
      );
    }
  }
);

export const getPTQuizCurrentThunk = createAsyncThunk(
  "preguntasTalentoQuiz/getCurrent",
  async (_, { rejectWithValue }) => {
    try {
      return await getPreguntasTalentoCurrentService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener la pregunta actual."
      );
    }
  }
);

export const sendPTQuizAnswerThunk = createAsyncThunk(
  "preguntasTalentoQuiz/sendAnswer",
  async (payload, { rejectWithValue }) => {
    try {
      return await sendPreguntasTalentoAnswerService(payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al guardar las respuestas."
      );
    }
  }
);

export const getPTQuizStatusThunk = createAsyncThunk(
  "preguntasTalentoQuiz/getStatus",
  async (_, { rejectWithValue }) => {
    try {
      return await getPreguntasTalentoStatusService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el estado."
      );
    }
  }
);

export const getPTQuizSummaryThunk = createAsyncThunk(
  "preguntasTalentoQuiz/getSummary",
  async (_, { rejectWithValue }) => {
    try {
      return await getPreguntasTalentoSummaryService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el resumen."
      );
    }
  }
);
